<main>
    <div class="content">
        <div class="paragraph">
            <h2>Career</h2>
            <p>NongHyup Finance received a license from the National Bank of Cambodia on 8 August 2018 to conduct the microfinance after NongHyup Bank had acquired 100% shares from SAMIC Microfinance Plc. It is currently operating in Phnom Penh and 8 provinces of Kandal, Kampong Speu, Takeo, Kampot, Kep, Preah Sihanouk, Siem Reap and Kampong Thom. These operating areas are expected to grow in the future.</p>
             <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Job Title</th>
                    <th scope="col">Location</th>
                    <th scope="col">Close Date</th>
                  </tr>
                </thead>

                <!-- English -->
                <tbody *ngIf="isEnglish()">
                  <tr *ngFor="let career of careerData">
                    <td><a href="/career/detail/{{ career.id }}">{{ career.title }}</a></td>
                    <td>{{ career.location }}</td>
                    <td>{{ career.close_date | date:'dd-MMMM-yyyy' }}</td>
                  </tr>
                </tbody>
                <!-- English -->

                <!-- Khmer -->
                <tbody *ngIf="isKhmer()">
                  <tr *ngFor="let career of careerData">
                    <td><a href="/career/detail/{{ career.id }}">{{ career.title_kh }}</a></td>
                    <td >{{ career.location_kh }}</td>
                    <td>{{ career.close_date | date:'dd-MMMM-yyyy' }}</td>
                  </tr>
                </tbody>
                <!-- Khmer -->

            </table>
            <h2>Application Information</h2>
            <p>Interested applicants should submit a cover letter together with updated CV, a recent photo (4 x 6) and/or expected salary to the HR Department of NongHyup Finance (Cambodia) Plc at the address below:</p>
            <h5>Head Office in Phnom Penh</h5>
            <p>Building No. 388A E1, E2, E3, Preah Monivong Blvd. Corner St. 352, Sangkat Boeng Keng Kang1, Khan Boeng Keng Kang, Phnom Penh.</p>
            <p><span>Email: </span>career&#64;nhfinance.com.kh</p>
            <p><span>Tel: </span>023 998 226 | 023 996 023</p>
            <p>Only short listed applicants will be contacted for interview.</p>
            <br>
            <!-- <h5>NongHyup Finance (Cambodia) Plc provides competitive package benefits within the industry, both financial and non-financial benefits to its employees, including the following:</h5>
            <ul>
                <li>Competitive salary</li>
                <li>13th month bonus</li>
                <li>Staff uniform allowance</li>
                <li>Productivity based incentive</li>
                <li>Maternity/paternity allowance</li>
                <li>Women’s Day allowance</li>
                <li>Severance benefits</li>
                <li>Education benefits (internal and external trainings or study)</li>
                <li>Insurance policies coverage – work related accidents, Group Hospital and surgical, and basic life.</li>
            </ul> -->
        </div>
        <div class="bottom-content-poster">
            <img [src]="baseApiUrl + '/uploads/images/customer_service/customer_service_1.jpg'" alt="">
            <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
        </div>
    </div>
</main>
